import { Component, Input } from '@angular/core';
import { DocumentViewerService } from '../../services/document-viewer.service';
import { DocumentManagementService } from '../../services/document-management/document-management.service';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { ColumnDefinition } from '../../models/dynamic-table/dynamic-table-data.model';

@Component({
  selector: 'app-shared-workbook-cell',
  templateUrl: './shared-workbook-cell.component.html',
  styleUrl: './shared-workbook-cell.component.scss'
})
export class SharedWorkbookCellComponent {
  @Input() col: ColumnDefinition;
  @Input() workbookRow: any;
  /** Subscription and Cleanup */
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  /**User Detail pop up */
  displayUserDetails: boolean = false;
  selectedUser: any;
  //files and pics
  allFiles = [];
  allPics = [];
  displayFiles = false;
  displayPics = false;

  ngOnInit() {
  }
  constructor(
    private readonly appMainService: AppMainService,
    private readonly messageService: MessageService,
    public documentManagementService: DocumentManagementService,
    private readonly documentViewerService: DocumentViewerService,
  ) { }

  //#region Tagged User Details Popup
  openTaggedUserDetails(event, userId: any) {
    event.stopPropagation();
    this.selectedUser = userId;
    this.displayUserDetails = true;
  }
  closeTaggedUserDetails() {
    this.selectedUser = null;
    this.displayUserDetails = false;
  }
  //#endregion Tagged User Details Popup

  //files and pics
  openFiles(e, files) {
    e.stopPropagation();
    this.allFiles = files;
    this.displayFiles = true;
  }
  openPics(e, pics) {
    e.stopPropagation();
    this.allPics = pics;
    this.displayPics = true;

  }
  hideFileViewModal(type) {
    if (type === 'pics') {
      this.displayPics = false;
      this.allPics = [];
    }
    else {
      this.displayFiles = false;
      this.allFiles = [];
    }
  }
  previewListingFile(event, data, isDownload = false) {
    event.stopPropagation();
    const documentPayload = {
      id: data?.id,
      isDefaultContentType: isDownload ? true : false,
      expirationTimeInMinutes: 5
    }
    this.appMainService.isShowSpinner('previewListingFile');
    this.documentManagementService.downloadDocument(documentPayload).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('previewListingFile');
        if (isDownload) {
          const fileUrl = response?.downloadLink; // Replace with your API's file URL field
          if (fileUrl) {
            window.open(fileUrl, '_blank'); // Open the file in a new tab
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document Download successfully!' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
          }
        } else {
          const getFileExtension = (filename: string) => filename.split('.').pop() || '';
          const extension = getFileExtension(data?.fileName);
          this.documentViewerService.previewDocument(extension, response);
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('previewListingFile');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
      }
    })
  }


  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }
}
